export default __webpack_public_path__ + "static/media/small rabbit.a9871c51.jpg";